<template>
  <van-tabbar
    class="tabbarBox"
    style="
      background-size: 100% 100%;
      background-position: center;
      background-color: transparent;
    "
    :style="{ backgroundImage: `url(${config.ui38.bottom_nav_bg})` }"
    v-model="active"
    z-index="100"
  >
    <!--  -->
    <van-tabbar-item
      v-for="(item, index) in tabClass"
      :key="index"
      style="position: relative; z-index: 99"
      @click="routerFun(item)"
      :name="item.router"
    >
      <div
        class="flex items-center"
        style="
          flex-direction: column;
          justify-content: space-between;
          height: 0.8rem;
          margin-bottom: 0.1rem;
        "
      >
        <div
          v-if="item.router == active"
          class="flex items-center justify-center"
          style="
            flex-direction: column;
            width: 0.8rem;
            height: 0.8rem;
            margin-top: -0.2rem;
          "
        >
          <img :src="item.active" style="width: 100%" />
        </div>
        <div
          v-else
          class="flex items-center justify-center"
          style="flex-direction: column; width: 0.5rem; height: 0.5rem"
        >
          <img
            :src="item.tab"
            :style="
              item.router == 'promote'
                ? { width: '0.95rem', marginTop: '-0.5rem' }
                : { width: '100%' }
            "
          />
        </div>
        <span>{{ item.className }}</span>
      </div>
      <!-- <i class="anticon" slot="icon">
        <i
          class="yj5rHjAv0U7RlHMzWr7F img skeleton-box"
          :style="{
            ...tbaCla,
            backgroundPosition: `${
              active == item.router
                ? item.active.backgroundPosition
                : item.tab.backgroundPosition
            }`,
            backgroundImage: `url(${_coloImg})`
          }"
        ></i>
      </i> -->
      <div
        v-if="badageCount > 0 && item.router == 'mine'"
        class="uh6csli2MHzFz87__Phx tool-tips r1QnBDk2QnzYN6t7hweu"
        style="
          --cu-top: -0.15rem;
          --cu-right: -0.1rem;
          --cu-left: unset;
          top: 0.1rem;
          right: 0.3rem;
          position: absolute;
          text-align: center;
        "
      >
        <p class="tool-tips-box sNgyWmhVEZVrbSGKDBra">
          {{ formatBadgeCount(badageCount) }}
        </p>
        <p class="tool-tips-tail YiNQnpSJUes7u5sqBZhp"></p>
      </div>
    </van-tabbar-item>
    <!-- config.festival_img -->
  </van-tabbar>
</template>

<script>
// 引入从iconfont 下载的symbox文件
// import '@/assets/icons/iconfont-svg.js'
// 引入本地的svg文件
// 定义一个加载目录的函数
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('@/assets/icons/svg', false, /\.svg$/);
// 加载目录下的所有的 svg 文件
requireAll(req);
import { mapState } from 'vuex';
export default {
  computed: {
    moneyInfo() {
      return this.$store.state.moneyInfo;
    },
    ...mapState(['popList', 'userInfo', 'config','vuex_token_head']),
    iconName() {
      return `${this.prefix}${this.name}`;
    },
    badageCount() {
      if (this.$store.state.moneyInfo) {
        return this.$store.state.moneyInfo.have_message;
      } else {
        return 0;
      }
    }
  },
  name: 'Icon',
  props: {
    name: String,
    active: {
      type: [String],
      required: 'home'
    }
  },
  data() {
    return {
      tabbarBoxBg: require('../../assets/icons/3Dian8/menu_bg.webp'),
      badgeConfig: {
        home: 0, // 首页徽章数
        mine: 3, // 个人中心徽章数
        event: 12, // 活动徽章数
        recharge: 0, // 充值徽章数
        withdraw: 5 // 提现徽章数
      },
      tabActive: '',
      tbaCla: {
        display: 'inline-block',
        position: ' relative',
        width: '0.5rem',
        height: '0.5rem',
        backgroundSize: '10.3714rem 10.1214rem'
      },
      toolbarConter: {
        _Inicio: this.$t('toolbarConter._Inicio'),
        _Promoção: this.$t('toolbarConter._Promoção'),
        _Agente: this.$t('toolbarConter._Agente'),
        _Suporte: this.$t('toolbarConter._Suporte'),
        _Perfil: this.$t('toolbarConter._Perfil'),
        _Depósito: this.$t('toolbarConter._Depósito'),
        _Saque: this.$t('toolbarConter._Saque'),
        _Login: this.$t('toolbarConter._Login'),
        _Registro: this.$t('toolbarConter._Registro')
      },
      toolbarConter2: {
        _Inicio: 'Inicio',
        _Promoção: 'Promoção',
        _Agente: 'Agente',
        _Suporte: 'Suporte',
        _Perfil: 'Perfil',
        _Depósito: 'Depósito',
        _Saque: 'Saque',
        _Login: 'Login',
        _Registro: 'Registro'
      },
      classList: {
        home: {
          router: 'home',
          className: this.$t('toolbarConter._Inicio'),
          tab: this.$store.state.config.ui38.bottom_nav_un_1,
          active: this.$store.state.config.ui38.bottom_nav_1
        },
        event: {
          router: 'event',
          className: this.$t('toolbarConter._Promoção'),
          tab: this.$store.state.config.ui38.bottom_nav_un_2,
          active: this.$store.state.config.ui38.bottom_nav_2
        },
        agente: {
          router: 'promote',
          className: this.$t('toolbarConter._Agente'),
          tab: this.$store.state.config.ui38.bottom_nav_un_3,
          active: this.$store.state.config.ui38.bottom_nav_3
        },
        suporte: {
          router: 'notice',
          className: this.$t('toolbarConter._Suporte'),
          tab: '',
          active: ''
        },
        mine: {
          router: 'mine',
          className: this.$t('toolbarConter._Perfil'),
          tab: this.$store.state.config.ui38.bottom_nav_un_5,
          active: this.$store.state.config.ui38.bottom_nav_5
        },
        recharge: {
          router: 'tan',
          className: this.$t('toolbarConter._Depósito'),
          tab: this.$store.state.config.ui38.bottom_nav_un_4,
          active: this.$store.state.config.ui38.bottom_nav_4
        },
        withdraw: {
          router: 'withdraw',
          className: this.$t('toolbarConter._Saque'),
          tab: '',
          active: ''
        },
        login: {
          router: 'login',
          className: this.$t('toolbarConter._Login'),
          tab: '',
          active: ''
        },
        register: {
          router: 'register',
          className: this.$t('toolbarConter._Registro'),
          tab: '',
          active: ''
        }
      },
      tabClass: []
    };
  },
  methods: {
    routerFun(e) {
      if (e.router == 'tan') {
        if (!this.vuex_token_head) {
          let rememberPassword = window.localStorage.getItem('rememberPassword')
          if (rememberPassword && rememberPassword.length) {
            this.$store.commit('isRecord');
            this.$store.commit('publicFun', ['isRecordType', 1]);
          } else {
            this.$store.commit('isRecord');
            this.$store.commit('publicFun', ['isRecordType', 0]);
          }
          this.active = this.tabActive;
          return false;
        }
        this.$store.commit('isDeposit', true);
        this.active = this.tabActive;
        return false;
      } else if (e.router == 'register' || e.router == 'login') {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', [
          'isRecordType',
          e.router == 'register' ? 0 : 1
        ]);
        this.active = this.tabActive;
        return false;
      } else {
        if (this.$store.state.userInfo && e.router == 'withdraw') {
          if (!this.$store.state.userInfo.set_withdraw_password) {
            this.$router.push({ name: 'security' });
            return false;
          }
        }
        this.$router.push({ name: e.router });
      }
      this.tabActive = e.router;
    },
    // 获取指定路由的徽章数量
    getBadgeCount(router) {
      if (router == 'mine' && this.moneyInfo) {
        return this.moneyInfo.have_message;
      } else {
        return 0;
      }
    },

    // 格式化徽章数字显示
    formatBadgeCount(count) {
      if (count <= 0) return '';
      if (count > 99) return '99+';
      return count.toString();
    },

    // 更新徽章数量
    updateBadge(router, count) {
      this.$set(this.badgeConfig, router, count);
    },

    // 清除徽章
    clearBadge(router) {
      this.$set(this.badgeConfig, router, 0);
    }
  },
  created() {
    this.tabActive = this.active;
    this.classList.home.className =
      this.$store.state.config.ui_type == 'a7'
        ? this.$t('toolbarConter._Inicio2')
        : this.$t('toolbarConter._Inicio');
    let useList = {
      unlogin: ['home', 'event', 'agente', 'recharge', 'mine'],
      login: ['home', 'event', 'agente', 'recharge', 'mine']
    };
    let isLogin = typeof this._vuex_token() == 'string' ? 'login' : 'unlogin';
    this.tabClass = [
      this.classList[useList[isLogin][0]],
      this.classList[useList[isLogin][1]],
      this.classList[useList[isLogin][2]],
      this.classList[useList[isLogin][3]],
      this.classList[useList[isLogin][4]]
    ];
  }
};
</script>

<style scoped>
.pendant-AGM4D,
.pendant-left-keCbM {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.pendant-center-bQBE8 {
  height: 100%;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}

.pendant-right-Pu6sD {
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.tabbarBox {
  /* -webkit-box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1); */
  height: 0.8rem;
}
.anticon {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  display: inline-block;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
}
.tabbarBox .van-tabbar-item__text {
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  height: 0.54rem;
  line-height: 1.3;
  max-width: 1.6rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: pre-wrap;
}

.tabbarBox .van-tabbar-item {
  background: transparent;
  -ms-flex-pack: end;
  color: #fff;
  font-size: 0.24rem;
  justify-content: center;
  padding-top: 0;
  align-items: center;
  /* justify-content: flex-end; */
  position: relative;
}
.tabbarBox .van-tabbar-item--active {
  background: transparent;
  color: var(--theme-filter-active-color);
}
.tabbar-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #ff4757;
  color: white;
  border-radius: 12px 12px 12px 0px;
  min-width: 18px;
  height: 12px;
  padding: 0 3px;
  font-size: 0.18rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.uh6csli2MHzFz87__Phx p {
  margin-bottom: 0;
}

.uh6csli2MHzFz87__Phx .YiNQnpSJUes7u5sqBZhp {
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid var(--theme-secondary-color-error);
  border-right: 0.07rem solid transparent;
  height: 0;
  width: 0;
}

.uh6csli2MHzFz87__Phx .T5xNMynUJQws22ZME9hV {
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid transparent;
  border-right: 0.07rem solid var(--theme-secondary-color-error);
  float: right;
}

.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
  background-color: var(--theme-secondary-color-error);
  border-radius: 0.125rem 0.125rem 0.125rem 0;
  color: #fff;
  font-size: 0.14rem;
  height: 0.22rem;
  line-height: 0.22rem;
  padding: 0 0.08rem;
  width: 100%;
}

.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra:lang(my_MM) {
  height: 0.26rem;
}

.uh6csli2MHzFz87__Phx .CmN8CVsfet8ieqBIT7mi {
  color: #ff0;
}

.uh6csli2MHzFz87__Phx .nc_NIDTLmXeUSFFfADOl {
  border-radius: 0.125rem 0.125rem 0 0.125rem;
}

li .tool-tips {
  max-width: calc(100% - 0.1rem);
}

li .tool-tips .tool-tips-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto;
}
</style>
